import {ContactModel} from '../models/checkout/Cart/Contact.model';
import {AddressModel} from '../models/checkout/Cart/Address.model';
import {DeliveryInfoModel} from '../models/checkout/Cart/DeliveryInfo.model';

export function isShippingDestinationSignificant(deliveryInfo: DeliveryInfoModel, isShippingFlow: boolean) {
  if (!isShippingFlow) {
    return isContactDefined(deliveryInfo.contact);
  }

  return isAddressSignificant(deliveryInfo.address);
}

function isContactDefined(contact?: ContactModel) {
  return Object.values(contact ?? /* istanbul ignore next */ {}).filter((value) => !!value).length > 0;
}

export function isAddressSignificant(address?: AddressModel) {
  const {country, subdivision, postalCode, subdivisionFullname, countryFullname, ...rest} =
    address ?? /* istanbul ignore next */ {};
  return Object.values(rest ?? /* istanbul ignore next */ {}).filter((value) => !!value).length > 0;
}
